/* jshint ignore: start */
// jscs:disable

(function($) {

    $.fn.PannableDiv = function() {
        // plugin
        var plugin = this;

        // settings
        plugin.OFF_SCREEN_PADDING = 600;
        plugin.IMAGES_MEDIUM_FLR = 210;
        plugin.IMAGES_MEDIUM_CEIL = 290;

        var $element = this;
        var screenWidth;
        var screenHeight;

        var elements_small = [];
        var elements_medium = [];
        var elements_large = [];

        var hasShown = false;

        var tween;
        var duration = 2;

        $element.data('PannableDiv', plugin);

        var conWidth = $(window).width();
        //and its height
        var imgHeight = $element.height();
        //get the nested img width
        var conHeight = $(window).height();
        //and its height
        var imgWidth = $element.width();
        //figure out how much of the image is not visible horizontally
        var excessWidth = imgWidth - conWidth;
        //and how much is not visible vertically
        var excessHeight = imgHeight - conHeight;
        //how far is this container from the left of the page
        var containerPositionLeft = 0;
        //and from the top
        var containerPositionTop = 0;

        var paddingXPercent = 0;
        var paddingYPercent = 0;

        plugin.init = function() {
        };

        plugin.enable = function() {
            $element.parent().off('mousemove', plugin.mouseMove);
            TweenMax.to($element, 1.10, {
                x: 0 + 'px',
                y: 0 + 'px',
                z: 0,
                ease: Power3.easeOut,
                overwrite:"all",
                onComplete: function() {
                    plugin.resize();
                    plugin.start();
                }
            });
        };

        window.stopPlugin = plugin.disable;

        plugin.resize = function(_event) {
            paddingXPercent = 500 - ($(window).width()/$element.width()) * 500;
            paddingYPercent = 700 - ($(window).height()/$element.height()) * 700;
            conWidth = $(window).width();
            //and its height
            imgHeight = $element.height() + paddingYPercent;
            //get the nested img width
            conHeight = $(window).height();
            //and its height
            imgWidth = $element.width() + paddingXPercent;

            //figure out how much of the image is not visible horizontally
            excessWidth = imgWidth - conWidth;
            //and how much is not visible vertically
            excessHeight = imgHeight - conHeight;
            //how far is this container from the left of the page
            containerPositionLeft = 0;
            //and from the top
            containerPositionTop = 0;
        };

        plugin.start = function() {
            if ($('html').hasClass('no-touch')) {
                var elements = $element.find('.parallax');
                var size;
                var currentElement;
                var i;
                for (i = 0; i < elements.length; i++) {
                    currentElement = $(elements[ i ]);
                    size = Math.max(currentElement.width(), currentElement.height());

                    if (size < plugin.IMAGES_MEDIUM_FLR) {
                        elements_small.push(currentElement);
                    } else if (size > plugin.IMAGES_MEDIUM_CEIL) {
                        elements_large.push(currentElement);
                    } else {
                        elements_medium.push(currentElement);
                    }
                }

                //TweenMax.to($element, 0, { alpha: 0 });
                hasShown = false;

                plugin.moveDomLayer(0, 0);
                $element.parent().off('mousemove', plugin.mouseMove);
                $element.parent().on('mousemove', plugin.mouseMove);

                // $element.css('border', '1px solid red');
            }
        },

        plugin.mouseMove = function(_event) {
            plugin.moveDomLayer(_event.clientX -= 50, _event.clientY -= 50);
        }

        plugin.pause = function() {
            tween.pause();
        };

        plugin.moveDomLayer = function(moveX, moveY) {

            //-- Disable smaller sizes
            excessWidth = (excessWidth < 0) ? 0 : excessWidth;
            excessHeight = (excessHeight < 0) ? 0 : excessHeight;

            //figure out how many pixels the mouse is from the left edge of the page
            var mouseoffLeftPage = (moveX > conWidth) ? conWidth : moveX;
            //and how many from the top edge of the page
            var mouseoffTopPage = (moveY > conHeight) ? conHeight : moveY;
            //figure out how many pixels the mouse is from the left edge of the page
            var mouseoffLeftPx = mouseoffLeftPage - containerPositionLeft;
            //and how many from the top edge of the page
            var mouseoffTopPx = mouseoffTopPage - containerPositionTop;
            //figure out the distance the mouse is from the left edge as a percentage (kind of - all the way to the right equals 1 not 100)
            var mouseoffLeftPercent = mouseoffLeftPx / (conWidth - (paddingXPercent / 2));
            //do the same for height
            var mouseoffTopPercent = mouseoffTopPx / (conHeight - (paddingYPercent / 2));
            //times the 'percentage' value by the amount of image hidden - so if your conatiner is 200px wide, your image 300px wide nd your mouse is half way across this value would be 0.5*100 which would give you 50 - which is exactly half the amount of image that is missing.
            //note this gets set as a minus value as we will be using a minus number to shift the image around.
            var setnewWidth = -(mouseoffLeftPercent * excessWidth);
            //do the same for the height
            var setnewHeight = -(mouseoffTopPercent * excessHeight);
            setnewWidth = setnewWidth + paddingXPercent /2;
            setnewHeight = setnewHeight + paddingYPercent / 2;

            tween = TweenMax.to($element, duration, {
                x: setnewWidth + 'px',
                y: setnewHeight + 'px',
                z: 0,
                ease: Sine.easeOut,
                overwrite: "all"
            });
/*
            // move the small images
            TweenMax.to(elements_small, 1.10, {
                x: setnewWidth / 8 + 'px',
                y: setnewHeight / 8 + 'px',
                alpha: 0.5,
                ease: Power3.easeOut
            });
            TweenMax.to(elements_medium, 1.10, {
                x: setnewWidth + 'px',
                y: setnewHeight + 'px',
                ease: Power3.easeOut
            });

            // move the large large
            TweenMax.to(elements_large, 1.10, {
                x: setnewWidth / 2 + 'px',
                y: setnewHeight / 2 + 'px',
                ease: Power3.easeOut
            });

            // move the medium images

    */
        };

        plugin.destroy = function() {
            $element.parent().off('mousemove', plugin.mouseMove);
        }

        plugin.init();

        return plugin;
    };
})(jQuery);

/* jshint ignore: end */
// jscs:enable
